import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme, { safe }) => ({
  content: {
    flexGrow: 1,
    justifyContent: 'space-between',
    paddingHorizontal: rw(16),
    paddingTop: rh(24),
    paddingBottom: Math.max(safe.bottom, rh(20)),
    gap: rh(32),
  },
  dots: { flexDirection: 'row', gap: rw(14), paddingVertical: rh(12) },
  dot: { width: rw(10), height: rw(10), borderRadius: rw(10), backgroundColor: theme.COLOR_BG_FILL },
  dotActive: { backgroundColor: theme.COLOR_TEXT_PRIMARY },
  keyboard: { width: '100%', alignSelf: 'center' },
  error: { color: theme.COLOR_TEXT_CRITICAL },
}))
